module.exports = __webpack_public_path__ + "fonts/0697040.ttf";